import { type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartRadar } from './component.js';

export const renderChartRadar = (component: DeesChartRadar): TemplateResult => {
  return component.renderChartFrame();
};
